import { render, staticRenderFns } from "./MatchingProfileForm.vue?vue&type=template&id=72f17db0&scoped=true&"
import script from "./MatchingProfileForm.vue?vue&type=script&lang=js&"
export * from "./MatchingProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./MatchingProfileForm.vue?vue&type=style&index=0&id=72f17db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f17db0",
  null
  
)

export default component.exports